import React from "react";
import { Bookmark, EditNote } from "@mui/icons-material";
import { Box, Button, Card, CardContent, Chip, Typography } from "@mui/material";
import { SongSavedInListInfo } from "../../../Entities/ChordListModel";

interface SongSavedListsBarProps {
  savedListsInfo: SongSavedInListInfo[];
  onEditNotes: () => void;
}

export const SongSavedListsBar: React.FC<SongSavedListsBarProps> = ({
  savedListsInfo,
  onEditNotes,
}) => {
  if (!savedListsInfo || savedListsInfo.length === 0) return null;

  const note = savedListsInfo.find((s) => s.notes)?.notes;

  return (
    <Card
      variant="outlined"
      sx={{
        mb: 1.5,
        borderRadius: 2,
        borderColor: "#bfdbfe",
        bgcolor: "#f8fafc",
      }}
    >
      <CardContent sx={{ p: { xs: 1, sm: 1.5 }, "&:last-child": { pb: { xs: 1, sm: 1.5 } } }}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          flexDirection={{ xs: "column", sm: "row" }}
          gap={1}
        >
          <Box display="flex" flexDirection="column" gap={0.5}>
            <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
              {savedListsInfo.map((info) => (
                <Chip
                  key={info.list_id}
                  icon={<Bookmark fontSize="small" />}
                  label={info.list_name}
                  size="small"
                  color="primary"
                  variant="outlined"
                  sx={{ fontWeight: 600 }}
                />
              ))}
            </Box>

            {note && (
              <Typography variant="body2" color="text.primary" sx={{ fontSize: "0.95rem" }}>
                {note}
              </Typography>
            )}
          </Box>

          <Button
            size="small"
            startIcon={<EditNote />}
            onClick={onEditNotes}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              alignSelf: { xs: "flex-end", sm: "center" },
            }}
          >
            Edit note
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};
